import { render, staticRenderFns } from "./postUnyo.vue?vue&type=template&id=193bdcbe&scoped=true&"
import script from "./postUnyo.vue?vue&type=script&lang=ts&"
export * from "./postUnyo.vue?vue&type=script&lang=ts&"
import style0 from "./postUnyo.vue?vue&type=style&index=0&id=193bdcbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193bdcbe",
  null
  
)

export default component.exports